var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-100 -100 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 47A47 47 0 0 0 47 0L62 0A62 62 0 0 1 0 62Z",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 67A67 67 0 0 0 67 0L81 0A81 81 0 0 1 0 81Z",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 86A86 86 0 0 0 86 0L100 0A100 100 0 0 1 0 100Z",
    fillOpacity: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 42
  }), /*#__PURE__*/React.createElement("g", {
    fill: "blue"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "blue",
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "blue",
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.08af1f70199610b2235bc9cbc07175c1.svg";
export { ForwardRef as ReactComponent };